export default {"src":"/_next/static/media/scale-wrapper-avatar.3d309ad6.svg","height":160,"width":120,"blurWidth":0,"blurHeight":0};